import { useContext, useEffect, useState } from "react";
import { ProcessContext } from "../../../../../../../../../contexts/ProcessContext";
import { useActionCallback } from "../../../../../../../../../utils/hooks/useActionCallback";
import { FLOW_MESSAGES } from "../../../../../../../../shared/components/flowMessages/components";

export const useTinkCallback = (onPrev) => {
  const {
    dispatch,
    state: { loan },
  } = useContext(ProcessContext);

  const [lastEvent, setLastEvent] = useState();
  const [showError, setShowError] = useState(false);

  const eventMethod = window.addEventListener
    ? "addEventListener"
    : "attachEvent";
  const eventer = window[eventMethod];

  const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

  eventer(messageEvent, (e) => onBankReaderEvent(e));

  const onBankReaderEvent = (e) => {
    if (!lastEvent || e.data.createdAt > lastEvent.createdAt) {
      setLastEvent(e.data);
    }
  };

  useEffect(() => {
    if (lastEvent) {
      if (lastEvent.msg === "bankReaderTinkWidget:ok") onSuccess();
      if (lastEvent.msg === "bankReaderTinkWidget:ko") onError();
    }
  }, [lastEvent]);

  const onSuccess = () => {
    if (!lastEvent || !lastEvent.msg === "bankReaderTinkWidget:ok") return;
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
    postCallbackBorrowerBankReader({
      state: lastEvent.state,
      accountVerificationReportId: lastEvent.accountVerificationReportId,
      transactionReportId: lastEvent.transactionReportId,
    });
  };

  const onError = () => onPrev();

  const postCallbackBorrowerBankReader = ({
    state,
    accountVerificationReportId,
    transactionReportId,
  }) => {
    dispatch({
      type: "REQUEST_POST_CALLBACK_BORROWER_BANK_READER_TINK",
      payload: {
        state: state,
        account_verification_report_id: accountVerificationReportId,
        transaction_report_id: transactionReportId,
      },
    });
  };

  useActionCallback(
    "REQUEST_POST_CALLBACK_BORROWER_BANK_READER_TINK_REJECTED",
    () => {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
      setShowError(true);
    }
  );

  useActionCallback(
    "REQUEST_POST_CALLBACK_BORROWER_BANK_READER_TINK_FULFILLED",
    () => {
      dispatch({
        type: "REQUEST_GET_LOAN",
        payload: loan.id,
      });
    }
  );

  useActionCallback("REQUEST_GET_LOAN_FULFILLED", () => {
    dispatch({
      type: "SET_FLOW_ITEM_OK",
    });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
    dispatch({
      type: "SET_FLOW_MESSAGE",
      payload: { id: FLOW_MESSAGES.SEND_OK.id },
    });
  });

  return { showError };
};
